export default {
  title: 'Opret API-nøgle',
  reveal_warning: 'Gem denne nøgle nu — den vises ikke igen.',
  form: {
    name: 'Navn',
    name_placeholder: 'f.eks. Produktionsnøgle',
  },
  buttons: {
    cancel: 'Annuller',
    create: 'Opret',
    done: 'Færdig',
  },
  toasts: {
    error: 'Nøglen kunne ikke oprettes. Prøv igen.',
  },
};
